import { r as m, x as v, c as h } from "../lit-element-8JrrHldg.js";
import { o as u } from "../style-map-F8T0o2lr.js";
import { p as s } from "../pwcProperty-CTLG9yrF.js";
import { c as g } from "../clsx-DB4S2d7J.js";
import "./pwc-icon.js";
class d extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.5 13.5A.5.5 0 0 1 1 13V4.5a.5.5 0 0 1 .5-.5h3.23l.855-1.275A.5.5 0 0 1 6 2.5h4a.5.5 0 0 1 .415.225L11.27 4h3.23a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5h-13Zm3.5-5a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm1 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8 4H2V5h3a.5.5 0 0 0 .415-.225L6.27 3.5h3.46l.855 1.275A.5.5 0 0 0 11 5h3v7.5Z" clip-rule="evenodd"></path></svg>';
  }
}
const c = "pi-camera";
customElements.get(c) || customElements.define(c, d);
var f = Object.defineProperty, w = Object.getOwnPropertyDescriptor, a = (l, r, p, o) => {
  for (var e = o > 1 ? void 0 : o ? w(r, p) : r, i = l.length - 1, n; i >= 0; i--)
    (n = l[i]) && (e = (o ? n(r, p, e) : n(e)) || e);
  return o && e && f(r, p, e), e;
};
let t = class extends m {
  createRenderRoot() {
    return this;
  }
  render() {
    return v`
      <div
        style=${u({
      backgroundImage: this.image.length ? `url(${this.image})` : "none"
    })}
        class=${g("PwcAvatar", {
      "PwcAvatar--text": !this.image.length,
      "PwcAvatar--lg": this.large,
      "PwcAvatar--upload": this.upload && this.large
    })}
      >
        <span class="PwcAvatar__text">${this.initial[0]}</span>
        <pwc-icon class="PwcAvatar__icon" icon="camera" size="16px"></pwc-icon>
      </div>
    `;
  }
};
a([
  s({ type: String, default: "" })
], t.prototype, "initial", 2);
a([
  s({ type: String, default: "" })
], t.prototype, "image", 2);
a([
  s({ type: Boolean, default: !1 })
], t.prototype, "large", 2);
a([
  s({ type: Boolean, default: !1 })
], t.prototype, "upload", 2);
t = a([
  h("pwc-avatar")
], t);
export {
  t as PwcAvatar
};
